var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.attachment)?_c('div',{staticClass:"files-group"},_vm._l((_vm.attachment),function(item,index){return _c('div',{key:index,staticClass:"files-item",on:{"click":function($event){return _vm.downloadFiles(item)}}},[_vm._v(_vm._s(item.name))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }